import type { Handleiding } from './soort';

export const ja: Handleiding = {
  code: 'ja',
  titel: '使い方',
  inleiding: 'Ask Gio Tolk は、言葉が通じない二人の会話を翻訳するよ。下にそれぞれのボタンの働きを書いてあるよ。',
  knop: '使い方を開く',
  sluiten: '閉じる',
  groepGebruik: '会話に参加する',
  groepBeheer: '設定と管理',
  delen: [
    {
      titel: '話す',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: '話しかけて',
          uitleg: '一度タップすると始まるよ。1秒ちょっと黙ると録音は自動で止まるし、もう一度タップしても止まる。1分たてばいずれにしても止まるよ。',
        },
        {
          kop: '音は一度にひとつだけ',
          uitleg:
            'アプリが話している間は録音できないよ。そして君が録音している間は、届いた翻訳が終わるまで待つ。そうしないとマイクがアプリの声を拾って、それを君が言ったと思ってしまうんだ。',
        },
        {
          kop: 'ここにメッセージを入力',
          uitleg: '話すのと並行して使えて、同じ翻訳を通るよ。エンターで送信、シフトとエンターで改行。',
        },
        {
          kop: '直す時間',
          uitleg: '書き起こされた文を送る前に読み返す秒数をここで決めるよ。ゼロにするとすぐ送られる。',
        },
        {
          kop: 'いつも自分で確認して送る',
          uitleg: 'もうカウントダウンはなし。どの文も君が送信を押すまで待つよ。一文ずつ確認したい人向け。',
        },
        {
          kop: '翻訳をすぐ再生',
          uitleg: 'オンだよ。先に読んで、聞くタイミングを自分で決めたいならオフにしてね。',
        },
      ],
    },
    {
      titel: 'メッセージを読む',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: '大きく表示されるもの',
          uitleg: '君の言語のものが大きく表示されるよ。自分の文なら元の文章で、アプリが正しく聞き取ったか確認できる。相手の文なら翻訳だよ。',
        },
        {
          kop: '原文か翻訳を開く',
          uitleg: 'もう一方の言語は下にたたまれているよ。その行をタップすると開く。',
        },
        {
          kop: '小さな三角',
          uitleg: '翻訳をもう一度再生するよ。',
        },
        {
          kop: 'しゃべる顔',
          uitleg: '相手自身の録音を再生するよ。話したメッセージにだけ出てきて、しかも「自分の声も送る」がオンのときだけ。入力したメッセージには録音がないんだ。',
        },
      ],
    },
    {
      titel: '画面上部のボタン',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'マイナスとプラス',
          uitleg: '文字を小さくしたり大きくしたりするよ。5段階で、設定は保存される。',
        },
        {
          kop: 'マイク',
          uitleg: 'どうせ入力しかしないなら、話すボタンを隠すよ。場所の節約になる。',
        },
        {
          kop: 'キーボード',
          uitleg: '入力欄を隠すよ。二つのうち必ずどちらかは残る。でないと何も言えなくなるからね。',
        },
      ],
    },
    {
      titel: '入るとき',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: '君は何語を話す',
          uitleg: 'この選択はボタンやお知らせの言語も決めるよ。だから二人は違う画面を見ることになる。それでいいんだ。',
        },
        {
          kop: '翻訳での君の声',
          uitleg: '男性の声か女性の声かを選んでね。これは部屋ではなく君自身のもの。参加者はそれぞれ別に選ぶよ。',
        },
        {
          kop: 'マイクの許可',
          uitleg: '入るときにブラウザが聞いてくるよ。断っても入力はできる。あとからアドレスバーの鍵マークで許可することもできる。',
        },
      ],
    },
    {
      titel: '下のたたまれた部分',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: '予備の単語リスト',
          uitleg: 'いつも同じように訳してほしい言葉：名前、専門用語、ブランド名。部屋全体に効くよ。',
        },
        {
          kop: '設定を変える',
          uitleg: '言語、声、語調、スペル修正は会話の途中でも変えられるよ。ここで変えたことはすぐ二人に効く。',
        },
      ],
    },
    {
      titel: '会話を始める',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: '会話の名前',
          uitleg: '空のままでいいよ。君の画面の上に出るだけで、誰と話しているか分かるようにするためのもの。',
        },
        {
          kop: '話者1と話者2',
          uitleg: 'この会話の二つの言語。先に入った人が最初の場所を取るよ。言語はあとから入れ替えられる。',
        },
        {
          kop: '翻訳の語調',
          uitleg:
            '左でくだけた言い方かていねいな言い方かを選び、右で雰囲気を選ぶよ：中立、親しげ、ビジネス、公式、パートナー。指示がないとモデルはほぼいつも硬い言い方を選ぶから、普通の会話ではよそよそしく聞こえるんだ。',
        },
        {
          kop: '自分の声も送る',
          uitleg: '相手は翻訳のほかに君自身の録音も聞けるよ。語学の勉強に便利。デリケートな話ではオフにしてね：録音を受け取った人はそれを保存できるから。',
        },
        {
          kop: '自分の文章の書き間違いを直す',
          uitleg: 'オンだよ。オフにすると、モデルが実際に何を聞き取ったかが見える。変な文が出たら、聞き間違えたのか、正しく聞いたあとで整えられたのかが分かる。',
        },
        {
          kop: 'PINコードあり',
          uitleg: 'コードは口頭で伝えて、リンクと同じメッセージには入れないでね。転送されたリンクから守ってくれるよ。',
        },
        {
          kop: 'QRコード',
          uitleg: '相手に読み取ってもらうか、リンクを送ってね。部屋は4時間で自動的に終了するよ。',
        },
      ],
    },
    {
      titel: '会話はどうなるのか',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: '文章は保存されない',
          uitleg: '二人が話した内容はデータベースに入らないよ。費用のために、いつどれだけ話したかだけを記録する。',
        },
        {
          kop: '録音は自動で消える',
          uitleg: '音声はメモリに10分だけ残って、そのあと消えるよ。',
        },
        {
          kop: '部屋は期限切れになる',
          uitleg: '作ってから4時間後。そのあとはリンクが使えなくなる。',
        },
        {
          kop: '予算の上限があるよ',
          uitleg: '部屋ごとと月ごと。いっぱいになるとアプリは翻訳をやめて、そう伝えるよ。故障じゃないんだ。',
        },
      ],
    },
  ],
};
